import { Fragment, useEffect, useState, useRef } from "react";
import Carousel, { consts } from "react-elastic-carousel";
import Image from "next/image";
import style from "./event_carousel.module.css";
import { eventCardItems } from "@/helpers/constant/content_data";
import { useRouter } from "next/router";

function EventCard(eventObj) {
  const [event] = useState(eventObj.eventObj);

  return (
    <div className={style.event_card}>
      <div className={style.event_card__cover}>
        <Image layout="fill" objectFit="cover" src={event.thumbnail} />
      </div>
      <div className={style.event_card__detail}>
        <div className={style.event_card__detail__title}>{event.name}</div>
        <div className={style.event_card__detail__date}>{event.date}</div>
      </div>
    </div>
  );
}

export default function EventCarousel() {
  const router = useRouter();
  const [eventList, setEventList] = useState([]);
  let eventCarouselRef = useRef(null);

  useEffect(() => {
    const _eventList = eventCardItems;
    setEventList(_eventList);
  }, []);

  const arrow = ({ type, onClick, isEdge }) => {
    const pointer =
      type === consts.PREV
        ? "/assets/icon-svg/arr-left-carousel.svg"
        : "/assets/icon-svg/arr-right-carousel.svg";
    return (
      <div className={style.arrow} onClick={onClick} disabled={isEdge}>
        <Image src={pointer} width={7} height={12} layout="fixed" />
      </div>
    );
  };

  const onItemClickHandler = (e, url) => {
    router.push(url);
  };

  return (
    <Fragment>
      {eventList && (
        <div className={style.events_carousel_wrapper}>
          <Carousel
            itemsToShow={3}
            showArrows={false}
            pagination={false}
            // renderArrow={arrow}
            ref={(ref) => (eventCarouselRef = ref)}
          >
            {eventList.map((event, index) => (
              <div
                key={index}
                className={style.event_card_wrapper}
                onClick={(e) => {
                  onItemClickHandler(e, event.url);
                }}
              >
                <EventCard eventObj={event} />
              </div>
            ))}
          </Carousel>
        </div>
      )}
    </Fragment>
  );
}
